import React from 'react'
import update from 'immutability-helper';
import { Modal, Button, Spinner, ModalBody, FormGroup, Input, ModalFooter, UncontrolledAlert } from 'reactstrap';
import { database } from '../firebase';

class ModalLista extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isOpen: false,
      isModal: props.isModal != null ? props.isModal : true,
      id: props.id !== null ? props.id : '',
      title: props.title !== null ? props.title : '', 
      nomes: '',
      nomeA: '',
      nomeB: '',
      nomeC: '',
      enviado: null
    }

    this.post = this.post.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    const isOpen = !this.state.isOpen;

    this.setState(state => update(state, {
      isOpen: { $set: isOpen }
    }))
  }

  handleTextChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    if (name == "nomeA") {
      this.setState(state => update(state, {
        nomeA: { $set: value }
      }))
    }
    else if (name == "nomeB") {
      this.setState(state => update(state, {
        nomeB: { $set: value }
      }))
    }
    else if (name == "nomeC") {
      this.setState(state => update(state, {
        nomeC: { $set: value }
      }))
    }
  }

  post() {
    this.setState(state => update(state, {
      isLoading: { $set: true },
      enviado: { $set: null }
    }), () => {
      var nomes = []
      if (this.state.nomeA.length > 4) nomes.push(this.state.nomeA);
      if (this.state.nomeB.length > 4) nomes.push(this.state.nomeB);
      
      if (this.state.nomeC.length > 4) nomes.push(this.state.nomeC);

      var restante = 0;

      const reference = database.ref('listas/').child(this.state.id).child('nomes');

      for (var i = 0; i < nomes.length; i++) {
        const nome = nomes[i].trim();
        
        if (nome !== undefined && nome !== "") {
          const key = reference.push().key;
          restante += 1;

          reference.child(key).set(nome, ((error) => {
            if (error === null) {
              restante -= 1;

              if (restante === 0) {
                this.setState(state => update(state, {
                  isLoading: { $set: false },
                  enviado: { $set: true }
                }));
              }
            }
        }))
        }
      }
    })
  }

  render() {
    return (<React.Fragment>
      <Modal className="modal-dialog modal-dialog-centered" isOpen={this.state.isOpen} toggle={this.toggle}> {
        this.state.isLoading ?
          <Button color="dark" style={{ margin: 0 + " auto", float: 'none' }} className="m-1" disabled onClick={this.loadFestas}><Spinner className="spinner-grow spinner-grow-sm"></Spinner> Aguarde...</Button>
          :
          <React.Fragment>
            <ModalBody>
              <p className="h4">{this.state.title}</p> {
                this.state.enviado === null ? 
                  <React.Fragment>
                    <p className="text-secondary">Digite os nomes separados por vírgula</p>
                    <FormGroup>
                      <Input className="mb-1" type="text" maxLength={50} name="nomeA" onChange={this.handleTextChange} value={this.state.nomeA} />
                      <Input className="mb-1" type="text" maxLength={50} name="nomeB" onChange={this.handleTextChange} value={this.state.nomeB} />
                      <Input className="mb-1" type="text" maxLength={50} name="nomeC" onChange={this.handleTextChange} value={this.state.nomeC} />
                    </FormGroup>
                  </React.Fragment>
                :
                  <UncontrolledAlert color="success">Nome(s) enviados com sucesso!</UncontrolledAlert>
              }
            </ModalBody>
            <ModalFooter> 
              <Button color="secondary" onClick={this.toggle}>Fechar</Button> {
                this.state.enviado === null ? 
                  this.state.nomeA.length > 4 || this.state.nomeB.length > 4 || this.state.nomeC.length > 4 ?
                    <Button color="primary" onClick={this.post}>Enviar</Button>
                  :
                    <Button color="primary" disabled onClick={this.post}>Enviar</Button>
                :
                  null
              }
            </ModalFooter>
          </React.Fragment>
        }
        </Modal>
        <Button color="primary" onClick={this.toggle}>Lista</Button>
      </React.Fragment>)
  }
}

export default ModalLista 